import React from 'react';

import { CHEVRON_LEFT_ICON, CHEVRON_RIGHT_ICON } from '../../../../../constants/images';
import { useHorizontalScroll } from '../../../../../hooks/useHorizontalScroll/useHorizontalScroll';
import BdsIconButton from '../../../Buttons/BdsIconButton/BdsIconButton';
import './SliderController.scss';

export interface ISliderController {
  totalDots: number;
  currentIndex: number;
  onDotClick: (index: number) => void;
  onPrevClick: () => void;
  onNextClick: () => void;
}

const SliderController = ({ totalDots, currentIndex, onDotClick, onPrevClick, onNextClick }: ISliderController) => {
  const { dragProps, isDragging } = useHorizontalScroll();

  const handleDotClick = (index: number) => {
    if (isDragging) return;
    onDotClick(index);
  };

  const handlePrevClick = () => {
    onPrevClick();
  };

  const handleNextClick = () => {
    onNextClick();
  };

  return (
    <div className={'slider-controller flex flex-row items-center justify-end w-full'}>
      <div
        className={'dots-list flex items-center'}
        {...{ ...dragProps, ref: dragProps.ref as React.RefObject<HTMLDivElement> }}
      >
        {[...Array(totalDots).keys()].map((number: number) => {
          return (
            <button
              key={`dot-${number}`}
              className={`dot ${currentIndex === number ? 'active' : ''}`}
              onClick={() => handleDotClick(number)}
            />
          );
        })}
      </div>

      <div className="buttons flex flex-row items-center ">
        <BdsIconButton
          className="icon-button"
          icon={CHEVRON_LEFT_ICON}
          size="sm"
          action={handlePrevClick}
          variant="inverse"
          disabled={currentIndex === 0}
        />
        <BdsIconButton
          className="icon-button"
          icon={CHEVRON_RIGHT_ICON}
          size="sm"
          action={handleNextClick}
          variant="inverse"
          disabled={currentIndex === totalDots - 1}
        />
      </div>
    </div>
  );
};

export default SliderController;
